export const costingToolAllowed = (project) => {
  return !(project.quoteSpecs.finish.cosmetic || 
    project.quoteSpecs.finish.nonStandardFinish ||
    project.quoteSpecs.itarCompliance ||
    project.quoteSpecs.highProjectValue ||
    project.quoteSpecs.rawExtrusionBar);
};
